import styled from 'styled-components';

export const AddNewReportFormCont = styled.form<{ isEffectSurvey: boolean }>`
  display: flex;
  position: relative;
  width: ${({ isEffectSurvey }) => (isEffectSurvey ? '325px' : '656px')};
  justify-content: space-between;
`;

export const FormFieldsCont = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FormCellCont = styled.div`
  position: relative;
`;

export const FormElement = styled.div`
  position: relative;
`;

export const Label = styled.span`
  text-align: start;
  position: relative;
  left: 5px;
`;
